var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer_area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer_row row"},[_c('h5',{staticClass:"version-header",attrs:{"if":"apiVersion"}},[_vm._v("Api Version: "+_vm._s(_vm.apiVersion))]),_c('h5',{staticClass:"version-header"},[_vm._v("UI Version: "+_vm._s(_vm.appVersion))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }